import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { login } from "../apiCalls/user";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";



const Login = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const dispatch = useDispatch();

  const { isFetching, error } = useSelector((state) => state.user);

  const handleClick = (e) => {
    console.log("btn clicked",);
    e.preventDefault();
    login(
      dispatch,
      {
        username,
        password,
      },
      successCheck
    );
  };

  const successCheck = (res) => {
    console.log("success response for login of admin", res.data);
    navigate("/");
    // window.location.reload("/");
  };

  console.log("Error", error);
  console.log("isFetching", isFetching);

  return (
    <section className="login-section">
      <div className="form-wrapper">
        <h2>SIGN IN</h2>
        <div className="form">
        <div className="form-input">
          <input
            type="text"
            placeholder="Enter Username"
            name="username"
            onChange={(e) => setUsername(e.target.value)}
          />
          </div>

          <div className="form-input">
          <input
            type="password"
            placeholder="Enter Password"
            name="password"
            onChange={(e) => setPassword(e.target.value)}
          />
          </div>
          <button
            className="btn mb-4 mt-1 w-100 br-2"
            onClick={handleClick}
            // disabled={isFetching}
          >
            LOGIN
          </button>
          {/* {error && <span className="text-red">Something went wrong!</span>} */}

          <div className="new-signup">
            <Link to="/reset-password" className="signup-links">Forgot Password?</Link>
            <Link to="/register" className="signup-links">Sign up</Link>
          </div>
          <div className="login-text mt-2">
            <p>you are here bcz you a good consumer and want to buy some premium for yourself...</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Login;
